package com.eladfinish.bible.contest.features.review

/**
 * Asks the store to show its own in-app rating sheet (Google Play In-App Review, StoreKit).
 *
 * The store decides whether anything is shown (both have quotas) and never tells the app
 * whether it was, or what the user chose. So this must never sit behind a button: the "rate"
 * toolbar action opens the store listing instead.
 */
interface InAppReviewLauncher {

    /** False where no store review sheet exists (web, desktop): nothing is counted or logged. */
    val isSupported: Boolean

    suspend fun requestReview(): ReviewRequestResult
}

sealed interface ReviewRequestResult {

    /** The request was handed to the store; the platform gives no completion signal (iOS). */
    data object Requested : ReviewRequestResult

    /** The store's flow ran to its end (Android). It may still have shown nothing. */
    data object Finished : ReviewRequestResult

    data class Failed(val reason: String) : ReviewRequestResult
}

internal object UnsupportedInAppReviewLauncher : InAppReviewLauncher {
    override val isSupported: Boolean = false
    override suspend fun requestReview(): ReviewRequestResult =
        ReviewRequestResult.Failed(reason = "unsupported")
}
